import {useQuery} from '@tanstack/react-query'

import {getDriverJob} from './api'
import {driverJobKeys} from './query-keys'

export function useDriverJob(jobId: string, accessToken: string) {
    return useQuery({
        queryKey: driverJobKeys.detail(jobId, accessToken),
        queryFn: () => getDriverJob(jobId, accessToken),
        enabled: Boolean(jobId && accessToken),
        refetchOnWindowFocus: 'always',
    })
}
